import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ToolComponent } from '@app/modules/tools/components/tool/tool.component';

const routes: Routes = [{ path: '', component: ToolComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ToolsRoutingModule { }